import { useState, useEffect } from "react";
import { useChartBar } from "../../hooks";

export default function Module_HealthAnalysisManagement_BarTrack({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  callMainAPI = () => null,
}) {
  const { renderBar } = useChartBar({
    setting: moduleData,
    isExportRawList: true,
  });
  const [chartData, setChartData] = useState({ raw: [], format: [] });

  useEffect(() => {
    let data = [
      {
        type: "投控",
        aa: 8,
        bb: 8,
      },
      {
        type: "連展",
        aa: 33,
        bb: 33,
      },
      {
        type: "連訊",
        aa: 19,
        bb: 14,
      },
      {
        type: "連騰",
        aa: 39,
        bb: 33,
      },
      {
        type: "連淨",
        aa: 18,
        bb: 8,
      },
      {
        type: "電能",
        aa: 4,
        bb: 4,
      },
      {
        type: "集團",
        aa: 121,
        bb: 100,
      },
    ];

    data = data.map((item) => ({
      ...item,
      cc: ((item.bb * 100) / item.aa).toFixed(0),
    }));

    setChartData({
      raw: data,
      format: data,
      export: null,
    });
  }, []);

  return (
    <>
      <div className="w-full overflow-auto">
        {renderBar({
          moduleTitle,
          options: {
            moduleData: {
              ...moduleData,
              // columns: [{ key: "uv" }, { key: "sv" }, { key: "pv" }],
            },
            chartData,
            callMainAPI,
          },
        })}
      </div>
    </>
  );
}
